// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3rF6E","location":"Header_location__3pcQ8"};